import React from 'react';
import classnames from 'classnames';
import { connect } from 'react-redux';
import { Route } from 'react-router-dom';
import { withRouter } from 'react-router';
import { appEnvironment } from '@/configurations/app-configs/app.setting.config';
// import CashAccountProfile from '@/components/MyAccount/CashAccountProfile/CashAccountProfile';
import AccountBalanceOneRow from '../../components/MyAccount/AccountBalance/AccountBalanceOneRow';
// import CurrencyBalance from '@/components/MyAccount/CurrencyBalance/CurrencyBalance';
// import FundManagement from '@/components/MyAccount/FundManagement/FundManagement';
import Portfolio from '../../components/MyAccount/Portfolio/Portfolio';
import TransactionHistory from '@/components/MyAccount/TransactionHistory/TransactionHistory';
// import AccountBalance from '@/components/MyAccount/AccountBalance/AccountBalance';
import '../../assets/styles/pages/my-account/my-account.scss';
// import { ctrlID } from '../../constants/ctr-id';

class MyAccount extends React.Component {
  constructor(props) {
    super(props)
  }

  render() {
    let { p_Identifier } = this.props;
    return (
      <div className="my-account-container">
        <section className="secion-top">
          <AccountBalanceOneRow />
        </section>
        <section className="section-center">
          <Portfolio pageSize={17} isFilter autoSizeColumns={false} />
        </section>
        <section className="section-bottom">
          <TransactionHistory />
        </section>
      </div>
    )
  }
}

class RouteWithSubRoutes extends React.Component {
  constructor(props) {
    super(props)
  }
  render() {
    return (
      <Route
        path={this.props.route.path}
        render={props => (
          // pass the sub-routes down to keep nesting
          <Component {...props} routes={route.routes} />
        )}
      />
    );
  }
}

MyAccount.defaultProps = {
  p_Identifier: appEnvironment.custom_ctr_configs.accountCtrl
}

export default withRouter(connect(

)(MyAccount))